﻿import $ from "jquery";
import ko from "knockout";

import TabModel from "./TabModel";

export default class RootModel {
	constructor(model, options) {
		const _ = this;

		_.$ep = $(`#${options.entryPointId}`);

		_.categories = model;

		_.options = options;
		_.options.simple = !options.inline && ccs_util.isMobile();

		const rootSuffix = _.options.simple
			? "simple"
			: options.inline ? "inline" : "hover";

		_.rootClass = `ccs-logo-${rootSuffix}`;

		_.template = _.options.simple
			? "ccs-hp-recommends-simple"
			: "ccs-hp-recommends-full";

		_.tabs = {};
		_.activeTab = ko.observable();

		_.goToTab(_.categories[0], null, true);

		if (!_.options.simple) {
			_.$ep.on("ccsResize", () => _.activeTab().updatePageSize());
		}

		$(document).on("ccs.logo-shown", function (e, eventInfo) {
			if (eventInfo.entryId === _.$ep.closest(".ccs-logo-ls-popup").attr("id")) {
				_.activeTab().parsePrices();
			}
		});
	}

	goToTab(category, e, firstRun) {
		const _ = this, options = _.options;

		if (!firstRun && _.activeTab().id === category.id) {
			return;
		}

		let targetTab = _.tabs[category.id];
		if (!targetTab) {
			_.tabs[category.id] = targetTab = new TabModel(category, options, firstRun);
		}

		_.activeTab(targetTab);

		if (options.inline) {
			targetTab.updatePageSize();
		}

		if (options.simple) {
			_.scrollTop();
		}

		if (!firstRun) {
			ccs_cc_log.dispatchEvent(category.clickEvent);
		}
	}

	scrollTop() {
		const $tab = this.$ep.find(".ccs-logo-tab");

		// CCSDT-7102
		const wos = "-webkit-overflow-scrolling";
		$tab.css(wos, "auto");
		$tab.scrollTop(0);
		$tab.css(wos, "");
	}

	isActiveTab(id) {
		return id === this.activeTab().id;
	}
}
